import { Alert } from 'antd';
import styles from './DraftNotice.module.css';

/** Warns that the PDF being previewed is not the signed document. Sits above
 *  the preview pane, never inside it — the PDF itself is rendered by the
 *  backend and must look exactly as it does when downloaded. */
export default function DraftNotice() {
  return (
    <Alert
      className={styles.notice}
      type="warning"
      showIcon
      title="This report is not finalized"
      description="You are previewing a draft. Values marked with ✦ are AI-derived and have not been reviewed."
    />
  );
}
